<template>
    <v-navigation-drawer id="appDrawer" v-model="drawer" fixed app :mini-variant.sync="mini" disable-resize-watcher>
        <v-layout column fill-height>
            <v-list>
                <v-list-tile :to="{name:'home'}">
                    <v-list-tile-action>
                        <v-icon>home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>Home</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name:'catalogue'}">
                    <v-list-tile-action>
                        <v-icon>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title :title="$t('message.256')">{{$t('message.256')}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name:'part'}">
                    <v-list-tile-action>
                        <v-icon>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title :title="$t('message.150')">{{$t('message.150')}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name:'interchange'}">
                    <v-list-tile-action>
                        <v-icon>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title :title="$t('message.243')">{{$t('message.243')}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name:'tecdoc'}">
                    <v-list-tile-action>
                        <v-icon>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title title="TecDoc">TecDoc</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile :to="{name:'arrivals'}">
                    <v-list-tile-action>
                        <v-icon>search</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title :title="$t('message.314')">{{$t('message.314')}}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <v-spacer></v-spacer>
            <v-list>
                <v-list-tile href="https://multipartseurope.com/" target="_blank">
                    <v-list-tile-action>
                        <v-icon>
                            link
                        </v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Main Website
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-layout>
    </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AppDrawer',
  data: () => ({
    mini: false,
    drawer: false,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  created () {
  },
  mounted () {
    this.$events.on('APP_DRAWER_TOGGLED', () => {
      this.drawer = (!this.drawer)
    })
  },
  methods: {
    ...mapActions(
      'application', {
        logout: 'logout'
      }
    ),
    internalLogout () {
      this.logout({ auth: this.$auth })
        .then(() => {
          this.$router.replace({ path: '/login' })
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$snotify.error(error.response.data.data.error)
          } else {
            this.$snotify.error(error.message)
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
